import { Spinner } from "alurkerja-ui";
import React from "react";

export const Loading: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <Spinner />
      <span>Getting Info</span>
    </div>
  );
};
